import { useEffect, useState } from 'react'
import { fetchEthUsdPrice, getCachedEthUsdPrice } from '@/lib/ethUsd'

export function useEthUsdPrice(): number | null {
  const [price, setPrice] = useState<number | null>(() => getCachedEthUsdPrice())

  useEffect(() => {
    let cancelled = false
    fetchEthUsdPrice().then((next) => {
      if (!cancelled)
        setPrice(next)
    })
    return () => {
      cancelled = true
    }
  }, [])

  return price
}
